// src/store/slices/templatesSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
} from "../thunks/templatesActions";

const initialState = {
  loading: false,
  templates: [],
  error: null,
};

const templatesSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    resetTemplatesState: (state) => {
      state.loading = false;
      state.templates = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchTemplates
      .addCase(fetchTemplates.pending, (s) => { s.loading = true; })
      .addCase(fetchTemplates.fulfilled, (s, a) => {
        s.loading = false;
        s.templates = a.payload;
      })
      .addCase(fetchTemplates.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload || a.error.message;
      })

      // createTemplate
      .addCase(createTemplate.fulfilled, (s, { payload }) => {
        s.templates.push(payload);
      })

      // updateTemplate
      .addCase(updateTemplate.fulfilled, (s, { payload }) => {
        const idx = s.templates.findIndex(t => t._id === payload._id);
        if (idx >= 0) s.templates[idx] = payload;
      })

      // deleteTemplate
      .addCase(deleteTemplate.fulfilled, (s, { payload }) => {
        s.templates = s.templates.filter(t => t._id !== payload);
      });
  },
});

export const templatesActions = templatesSlice.actions;
export default templatesSlice.reducer;
